import React from 'react';
import { JoinPageTranslations } from '../joinPageTranslations';
import { ShText } from '@shoootin/translations';
import { ShRow, ShCol } from '@shoootin/components-web';

export const MaterialInfos = () => {
  return (
    <>
      <ShRow className="photograph-text">
        <ShCol xs={60} md={30}>
          <ShText message={JoinPageTranslations.materialInfos} tagName="p" />
        </ShCol>
      </ShRow>
      <ShRow className="photograph-text">
        <ShCol xs={60} md={30}>
          <p>
            <strong>
              <ShText message={JoinPageTranslations.materialInfosSubtitle1} />
            </strong>
            <br />
            <ShText message={JoinPageTranslations.materialInfosDescription1} />
          </p>
        </ShCol>
        <ShCol xs={60} md={30}>
          <p>
            <strong>
              <ShText message={JoinPageTranslations.materialInfosSubtitle2} />
            </strong>
            <br />
            <ShText message={JoinPageTranslations.materialInfosDescription2} />
          </p>
          <p>
            <strong>
              <ShText message={JoinPageTranslations.materialInfosSubtitle3} />
            </strong>
            <br />
            <ShText message={JoinPageTranslations.materialInfosDescription3} />
          </p>
        </ShCol>
      </ShRow>
    </>
  );
};
